import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "@flat-ui";
import { MemberHeaders } from "@components/table/members/members-table-utils";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { useMembersUtils } from "@hooks/use-member-utils";
import { Box } from "@mui-wrapper";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { UiUtils } from "@stellar/utils";
import { withEllipsis } from "@styles/common-styles";
/** Shows the basic information in a member column */
export function BasicInfoMemberColumn(t0) {
  const $ = _c(24);
  const {
    member,
    columnType
  } = t0;
  const {
    handleErrorWithToast
  } = useErrorContext();
  const {
    openProfilePage
  } = useMembersUtils();
  const t1 = member?.id;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      memberId: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    canViewCompanyMemberProfile
  } = useHasUserValidRoleCompanyLevel(t2);
  let entityValue;
  bb0: switch (columnType) {
    case MemberHeaders.email:
      {
        entityValue = member.email || UiUtils.DASH;
        break bb0;
      }
    case MemberHeaders.user:
    case MemberHeaders.name:
      {
        entityValue = member.name ?? UiUtils.DASH;
        break bb0;
      }
    default:
      {
        entityValue = UiUtils.DASH;
        handleErrorWithToast({
          id: `BasicInfoMemberColumn-${Date.now().toString()}`,
          title: `Unexpected columnType: ${columnType}`,
          error: `Unexpected columnType: ${columnType}`
        });
      }
  }
  let t3;
  if ($[2] !== entityValue) {
    t3 = <var>{entityValue}</var>;
    $[2] = entityValue;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const entityProp = t3;
  if (FaroCoreApiUtils.Member.isTeam(member)) {
    if (columnType === MemberHeaders.name) {
      let t4;
      if ($[4] !== entityProp) {
        t4 = <Tooltip component="div" title={entityProp}>{entityProp}</Tooltip>;
        $[4] = entityProp;
        $[5] = t4;
      } else {
        t4 = $[5];
      }
      return t4;
    }
    if (columnType === MemberHeaders.email) {
      let t4;
      if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <var>{UiUtils.DASH}</var>;
        $[6] = t4;
      } else {
        t4 = $[6];
      }
      return t4;
    }
  }
  const isTooltipVisible = typeof entityValue === "string" && entityValue.trim() !== "" && entityValue !== UiUtils.DASH;
  if (!canViewCompanyMemberProfile) {
    const t4 = isTooltipVisible ? entityProp : "";
    let t5;
    if ($[7] !== entityProp || $[8] !== t4) {
      t5 = <Tooltip component="div" title={t4}>{entityProp}</Tooltip>;
      $[7] = entityProp;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  const t4 = isTooltipVisible ? entityProp : "";
  const t5 = columnType === MemberHeaders.email ? "normal" : "bold";
  let t6;
  if ($[10] !== t5) {
    t6 = {
      ...withEllipsis,
      fontWeight: t5
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline"
      }
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== columnType || $[14] !== member || $[15] !== openProfilePage) {
    t8 = event => {
      event.stopPropagation();
      openProfilePage({
        member,
        source: `user ${columnType} column`
      });
    };
    $[13] = columnType;
    $[14] = member;
    $[15] = openProfilePage;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== entityProp || $[18] !== t8) {
    t9 = <Box component="var" sx={t7} onClick={t8}>{entityProp}</Box>;
    $[17] = entityProp;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t4 || $[21] !== t6 || $[22] !== t9) {
    t10 = <Tooltip component="div" title={t4} sx={t6}>{t9}</Tooltip>;
    $[20] = t4;
    $[21] = t6;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}